import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';
import { css } from '@emotion/react';

export const StatsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 1rem;
  background-color: ${Theme.colors.G_6};
  border-radius: 0.5rem;
  margin-bottom: 1.25rem;
`;

export const StatItem = styled.div<{ urgent?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: white;
  border-radius: 0.25rem;
  border: 0.0625rem solid ${Theme.colors.G_3};

  ${({ urgent }) =>
    urgent &&
    css`
      border-color: ${Theme.colors.WARNING_RED};
      background-color: ${Theme.colors.WARNING_RED}20;
    `}
`;

